<template>
  <div :disabled="button_loading" id="page-loading">
    <!-- add/editfamzy charge form  -->
    <div class="vx-row mb-2">
      <div class="vx-col w-full md:w-1/3 sm:w-1/2">
        <vs-input
          class="w-full"
          label-placeholder="Experience"
          v-model="experience"
          v-validate="'required|between:1,100'"
          type="number"
          name="experience"
          @keyup.enter="addUpdateExperience()"
        />
        <span class="text-danger text-sm">{{
          errors.first("experience")
        }}</span>
      </div>
    </div>
    <!-- end add/editfamzy charge form  -->

    <div class="vx-row">
      <div class="vx-col w-full col md:w-1/3 sm:w-1/2 pt-4 text-center">
        <vs-button
          class="mr-3 mb-2 success"
          color="success"
          @click.prevent="addUpdateExperience()"
          >{{ $t("labels.Submit") }}</vs-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      experience: "",
    };
  },

  mounted() {
    this.setValidationMessage();
    this.getViewDetail();
  },

  methods: {
    loading() {
      this.loading(true, "#page-loading");
    },
    // get view famzy charge form
    getViewDetail() {
      this.button_loader_success(true, "#page-loading");
      let input = {
        charge: this.experience,
        code: "experience-dropdown",
      };

      axios
        .get("admin/getCharge/experience-dropdown", input)
        .then((response) => {
          this.button_loader_success(false, "#page-loading");
          console.log(response);
          let data = response.data.data;
          this.experience = data[0].value;
          console.log(this.charge);
        })
        .catch((e) => {
          this.showError(e);
        });
    },
    // update form
    addUpdateExperience() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.button_loader_success(false, "#page-loading");
          this.saveCharge();
        }
      });
    },
    // save/add form
    saveCharge() {
      this.button_loader_success(true, "#page-loading");
      let input = {
        value: this.experience,
        code: "experience-dropdown",
      };
      axios
        .post("admin/setCharge", input)
        .then((response) => {
          this.button_loader_success(false, "#page-loading");
          let data = response.data;
          this.$vs.notify({
            text: data.message,
            color: "success",
            position: "top-right",
          });
        })
        .catch((e) => {
          this.showError(e);
        });
    },
  },

  clearInput() {
    charge = null;
  },
};
</script>